import api from '../../api';

const path = '/services';

export const addServicesRequest = (values) => api.post(`${path}/add`, values);
export const editServicesRequest = (updates) =>
    api.put(`${path}/edit/${updates.id}`, {
        updates,
    });
export const getServicesRequest = (id) => api.get(`${path}/get/${id}`);
export const getServicesListRequest = (params) =>
    api.get(`${path}/get`, { params });
export const deleteServicesRequest = (id) => api.delete(`${path}/delete/${id}`);
export const updateServicesRequest = (updates) =>
    api.put(`${path}/update/${updates.id}`, updates);
